import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  getServiceType({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: "/report/newPlan/findServiceTypeByStudentId",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getStudentInfoById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/getById`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  smartReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/report_v2/plan/aiGenerateScheme`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getBatchScoreInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/batchManagement/select`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  openNextStep({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/openNextStep`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getBindInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/bindCode/bindInfo`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  remind({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/remind`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  bind({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/bindCode/bind`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  checkStringCode({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/academicPlanning/checkStringCode",
        params: params,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  checkResult({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/academicPlanning/checkResult",
        params: params,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getOccupationList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/occupationEvaluation/answerList",
        params: params,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selectSpecialityLibrary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/occupationEvaluation/selectSpecialityLibrary",
        params: params
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
      // axios.post(`/occupationEvaluation/selectSpecialityLibrary`, params).then(response => {
      //   resolve(response);
      // }).catch(error => {
      //   reject(error);
      // });
    });
  },
  findTeacherSpeciality({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/occupationEvaluation/findTeacherSpeciality`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  insertSpecialityLibrary({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/occupationEvaluation/insertSpecialityLibrary`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  selectSpeciality({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "/occupationEvaluation/findTeacherSpecialityOne",
        params: params,
        headers: {
          "Content-Type": "application/json"
        }
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  getUserInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/getUserInfo`, params).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  editReportState({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/academicPlanning/editReportState',
        params: params,
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  checkNewZhiYeStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/baokao/student/checkNewZhiYeStatus`, { params }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  }
};
